import { firebaseAuth } from '@/services/firebaseApp'
import { createNotification, NotificationStatus, NotificationType } from '@/utils/notificationUtils'

export const copyToken = async () => {
  const firebaseUser = firebaseAuth.currentUser

  if (!firebaseUser) {
    createNotification(
      'No Token Available',
      'There is no Firebase user signed in',
      NotificationType.SIMPLE,
      NotificationStatus.ERROR,
    )

    return
  }

  try {
    const token = await firebaseUser.getIdToken()
    await navigator.clipboard.writeText(token)

    const tokenSlice = `${token.slice(0, 8)}...${token.slice(-8)}`
    createNotification('Token', { token: tokenSlice }, NotificationType.TOKEN)
  } catch {
    createNotification(
      'Unable to Copy Token',
      'The Firebase token could not be copied to the clipboard',
      NotificationType.SIMPLE,
      NotificationStatus.ERROR,
    )
  }
}
